import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Switch, Table, Tooltip } from "antd";
import axios from "axios";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import MerchantProductInfo from "../../../merchant/products/product/MerchantProductInfo";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";

const MerchantEmployeeProducts = () => {
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedData, setSelectedData] = useState(null);
  const [productInfoDrawer, setProductInfoDrawer] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);

  const columns = [
    {
      title: "",
      dataIndex: "",
      ellipsis: true,
      render: (text) => (
        <Switch
          onChange={() =>
            onChangeProdStatus(parseInt(text.status), text.id, "products")
          }
          checked={Boolean(parseInt(text.status))}
          size="small"
        />
      ),
    },
    {
      title: "Product",
      dataIndex: "product",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Purchase SRP",
      dataIndex: "purchase_srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "SRP",
      dataIndex: "srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },

    ...(Boolean(
      parseInt(
        subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
      )
    )
      ? [
          {
            title: "Available",
            dataIndex: "quantity",
            align: "center",
            // render: (text, record) => <p>{calculateAvailability(text)}</p>,
            render: (text, record) => (
              <p style={{ textAlign: "right" }}>{text}</p>
            ),
            visible: false,
          },
        ]
      : []),
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 110,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 110 }}>
          <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const columns2 = [
    {
      title: "",
      dataIndex: "",
      ellipsis: true,
      width: 50,
      render: (text) => (
        <div>
          <Switch
            onChange={() =>
              onChangeProdStatus(parseInt(text.status), text.id, "variants")
            }
            checked={Boolean(parseInt(text.status))}
            size="small"
          />
        </div>
      ),
    },
    {
      title: "Variant",
      dataIndex: "product",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Purchase SRP",
      dataIndex: "purchase_srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "SRP",
      dataIndex: "srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 160,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 160 }}>
          <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const tableColumns2 = columns2.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const onChangeProdStatus = (status, id, type) => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("id", id);
    formdata.append("status", parseInt(status) === 1 ? 0 : 1);
    formdata.append("type", type);
    setLoading(true);
    axios
      .post("user/merchant/update-status-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated status successfully.");
          getProductList();
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getProductList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getProductList();
  }, [getProductList]);

  const searchable = productList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <MerchantEmployeeLayout>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search"
              placeholder="Search product"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
        </div>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
          // expandable={{
          //   expandedRowRender: (record) => (
          //     <div style={{ margin: 0 }}>
          //       {record.productvariants.length > 0 ? (
          //         record.productvariants.map((data, index) => (
          //           <div
          //             key={index}
          //             style={{
          //               marginLeft: 40,
          //               borderBottom: "1px solid #e5e5e5",
          //               padding: 10,
          //               display: "flex",
          //             }}
          //           >
          //             <div style={{ flexGrow: 1 }}>
          //               <Switch
          //                 // onChange={() =>
          //                 //   onChangeProdStatus(parseInt(text.status), text.id)
          //                 // }
          //                 checked={Boolean(parseInt(data.status))}
          //                 size="small"
          //                 style={{ marginRight: 30 }}
          //               />
          //               {data.product} - {data.description}
          //             </div>
          //             <div>
          //               <Tooltip title="Product Info">
          //                 <Button
          //                   type="dashed"
          //                   shape="circle"
          //                   onClick={() => {
          //                     setSelectedData(data);
          //                     setProductInfoDrawer(true);
          //                   }}
          //                   icon={<InfoCircleOutlined />}
          //                 />
          //               </Tooltip>
          //             </div>
          //           </div>
          //         ))
          //       ) : (
          //         <div
          //           style={{
          //             width: "100%",
          //             display: "flex",
          //             justifyContent: "center",
          //             color: "red",
          //           }}
          //         >
          //           No variant found!
          //         </div>
          //       )}
          //     </div>
          //   ),
          //   rowExpandable: (record) => parseInt(record.has_variant) === 1,
          // }}.
          expandable={{
            expandedRowRender: (record) => (
              <div
              // style={{ margin: 0 }}
              >
                <Table
                  {...tableProps}
                  columns={tableColumns2}
                  dataSource={
                    record.productvariants.length > 0
                      ? record.productvariants
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record2) => record2.id}
                  pagination={false}
                />
              </div>
            ),
            rowExpandable: (record) => parseInt(record.has_variant) === 1,
          }}
        />
      </div>

      {productInfoDrawer && (
        <MerchantProductInfo
          open={productInfoDrawer}
          close={() => setProductInfoDrawer(false)}
          selectedData={selectedData}
        />
      )}
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeProducts;
